// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-container[data-v-3b7d6670]{border:2px solid #47b4e6;border-radius:5px;padding:16px 24px}", ""]);
// Exports
module.exports = exports;
